<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Course
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="errors && (errors.general || errors.network)"
            type="error"
            dense
            outlined
          >
            {{ errors.general || errors.network }}
          </v-alert>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Course Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="supervisor"
                v-model="form.subject_id"
                :items="Subjects"
                label="Subject"
                prepend-icon="mdi-book"
                :error-messages="errors.subject_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6" md="3" lg="3">
              <v-autocomplete
                :items="duration"
                label="Select Duration"
                v-model="form.course_duration"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6" md="4" lg="4">
              <v-autocomplete
                v-model="form.rank_ids"
                :items="ranks"
                label="Applicable Ranks"
                prepend-icon="mdi-account-group"
                multiple
                chips
                deletable-chips
                small-chips
                item-text="text"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col sm="12 mt-9">
              <h2>Document Upload</h2>
              <br />
              <input
                type="file"
                id="file_document"
                name="file_document"
                ref="file_document"
                @change="DocumentPath"
              />
              <br />
              <v-btn
                v-if="form.document_path != null"
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="
                  ($refs.file_document.value = null), (document_path = null)
                "
                >Remove</v-btn
              >
            </v-col>

            <v-col sm="12 mt-9">
              <h2>Video Upload</h2>
              <br />
              <input
                type="file"
                id="file_video"
                name="file_video"
                ref="file_video"
                @change="VideoPath"
                accept="video/*"
              />
              <br />
              <v-btn
                v-if="form.video_path != null"
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file_video.value = null), (video_path = null)"
                >Remove</v-btn
              >
            </v-col>
            <v-row class="mb-2" style="padding: 12px">
              <v-col sm="12" class="pb-0">
                <h2 class="font-weight-bold mb-2 mt-2">Course Text *</h2>
              </v-col>
              <v-col>
                <vue-editor v-model="form.text" class="form-control" />
                <div v-if="errors && errors.text" class="error-message">
                  <span style="color: red">{{ errors.text }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-2" style="padding: 12px">
              <v-col sm="12" class="pb-0">
                <h2 class="font-weight-bold mb-2 mt-2">Certificate Content *</h2>
              </v-col>
              <v-col>
                <vue-editor
                  v-model="form.course_content"
                  class="form-control"
                  :error-messages="errors.course_content_validate"
                />
                <div
                  v-if="errors && errors.course_content_validate"
                  class="error-message"
                >
                  <span style="color: red"
                    >Certificate content is required and must be between 1
                    and 1500 characters.</span
                  >
                </div>
              </v-col>
            </v-row>
            <v-col sm="12">
              <h2>Exam Details</h2>
            </v-col>
            <v-col sm="2">
              <v-text-field
                v-model="form.passing_marks"
                outlined
                label="Passing Percentage *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.passing_marks"
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-text-field
                v-model="form.no_of_attempt"
                outlined
                label="No Of Attempts *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.no_of_attempt"
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-text-field
                v-model="form.exam_duration"
                outlined
                label="Exam Duration*"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.exam_duration"
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-text-field
                v-model="form.no_of_quiz"
                outlined
                label="No of Quiz*"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.no_of_quiz"
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <v-switch
                v-model="form.is_expire"
                inset
                :label="`Expire: ${form.is_expire == 1 ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="2">
              <v-switch
                v-model="form.is_pre_join"
                inset
                :label="`Pre-Join: ${form.is_pre_join ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>

          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save"> Submit </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  name: "CourseCreatePage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        is_active: true,
        is_pre_join: false,
        text: "",
        rank_ids: [], // Selected rank IDs for course-rank relationship
      },
      isLoading: false,
      Subjects: [],
      duration: [],
      ranks: [], // Available ranks for multi-select
      document_path: "",
      video_path: "",
      error_message: null,
    };
  },

  mounted() {
    this.getMasters();
  },
  methods: {
    DocumentPath(e) {
      const file = e.target.files[0];
      this.document_path = URL.createObjectURL(file);
    },
    VideoPath(e) {
      const file = e.target.files[0];
      this.video_path = URL.createObjectURL(file);
    },
    async getMasters() {
      try {
        let response = await axios.get("value_lists/showAll");
        let rawData = response.data?.data || [];

        // Group data by category (value_id)
        let masters = {
          vessels: rawData.filter(item => item.value_id === 6),
          ranks: rawData.filter(item => item.value_id === 1),
          subjects: rawData.filter(item => item.value_id === 3),
          duration: rawData.filter(item => item.value_id === 2),
          nationality: rawData.filter(item => item.value_id === 4),
          birth_place: rawData.filter(item => item.value_id === 5),
        };

        console.log('Course create: Value lists data received:', masters);

        // Clear existing data
        this.Subjects = [];
        this.duration = [];
        this.ranks = [];

        // Handle ranks data for multi-select
        if (masters.ranks && Array.isArray(masters.ranks)) {
          masters.ranks.forEach((rank) => {
            if (rank && rank.id && rank.description) {
              this.ranks.push({
                text: rank.description,
                value: rank.id, // Use ID for pivot table relationship
              });
            }
          });
        }

        // Handle subjects data
        if (masters.subjects && Array.isArray(masters.subjects)) {
          masters.subjects.forEach((Subject) => {
            if (Subject && Subject.id && Subject.description) {
              this.Subjects.push({
                id: Subject.id,
                text: Subject.description,
                value: Subject.id,
              });
            }
          });
        }

        // Handle duration data
        if (masters.duration && Array.isArray(masters.duration)) {
          masters.duration.forEach((duration) => {
            if (duration && duration.id && duration.description) {
              this.duration.push({
                id: duration.id,
                text: duration.description,
                value: duration.code || duration.description,
              });
            }
          });
        }

        console.log('Course create: Masters data loaded - Subjects:', this.Subjects.length, 'Duration:', this.duration.length, 'Ranks:', this.ranks.length);
      } catch (error) {
        console.error('Course create: Error loading masters data:', error);
        this.Subjects = [];
        this.duration = [];
        this.ranks = [];
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.created_by_id = this.user.id;

        // Create course via API (works for both online and offline/Electron mode)
        let course = await axios.post("/course", this.form);
        this.course = course.data.data || course.data;
        console.log('Course created response:', this.course);

        // Handle file upload only if files were selected and course was created
        if (this.course && this.course.id) {
          const hasDocument = this.$refs.file_document && this.$refs.file_document.files && this.$refs.file_document.files.length > 0;
          const hasVideo = this.$refs.file_video && this.$refs.file_video.files && this.$refs.file_video.files.length > 0;

          if (hasDocument || hasVideo) {
            await this.handleFileUpload();
          }
        }

        this.$router.push("/course");
        this.isLoading = false;
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.error_message = error.response.data.errors;
        } else {
          console.error("Error creating course:", error);
        }
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (!this.course || !this.course.id) {
        console.warn("Cannot upload files: No course ID");
        return;
      }

      const CourseId = this.course.id;
      const document_file = this.$refs.file_document && this.$refs.file_document.files ? this.$refs.file_document.files[0] : null;
      const video_file = this.$refs.file_video && this.$refs.file_video.files ? this.$refs.file_video.files[0] : null;

      if (!document_file && !video_file) {
        console.log("No files to upload");
        return;
      }

      this.isLoading = true;
      let formData = new FormData();
      formData.append("id", CourseId);

      if (document_file) {
        formData.append("document_path", document_file);
        console.log("Uploading document:", document_file.name);
      }
      if (video_file) {
        formData.append("path_video", video_file);
        console.log("Uploading video:", video_file.name);
      }

      try {
        const response = await axios.post("video_and_document_upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("File upload successful:", response.data);
      } catch (error) {
        console.error("File upload failed:", error);
      }
      this.isLoading = false;
    },
  },
};
</script>
